// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-winnin-logo {
  fill: var(--gray);
  color: var(--gray);
  transition: opacity 0.3s ease;
  padding-right: 20px;
  display: flex;
  align-items: center;
  color: var(--gray_dark2);
  text-decoration: none !important;
}
.header-winnin-logo svg {
  fill: var(--gray_dark2);
}
.header-winnin-logo .pipe {
  background: var(--gray_dark2);
  margin: 0 10px;
  height: 20px;
  width: 1px;
  display: block;
  position: relative;
  top: 3px;
}
.header-winnin-logo .text {
  display: inline-block;
  font-size: 24px;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/Logo/index.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,gCAAA;AACF;AACE;EACE,uBAAA;AACJ;AAEE;EACE,6BAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AAAJ;AAGE;EACE,qBAAA;EACA,eAAA;EACA,cAAA;AADJ","sourcesContent":[".header-winnin-logo {\n  fill: var(--gray);\n  color: var(--gray);\n  transition: opacity 0.3s ease;\n  padding-right: 20px;\n  display: flex;\n  align-items: center;\n  color: var(--gray_dark2);\n  text-decoration: none !important;\n\n  svg {\n    fill: var(--gray_dark2);\n  }\n\n  .pipe {\n    background: var(--gray_dark2);\n    margin: 0 10px;\n    height: 20px;\n    width: 1px;\n    display: block;\n    position: relative;\n    top: 3px;\n  }\n\n  .text {\n    display: inline-block;\n    font-size: 24px;\n    line-height: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
